import React from 'react';
import { SegmentedControl } from '@spark';

/**
 * Template / Preview switch for the prompt editor (Figma small segmented
 * control at the right of the User Prompt head).
 */
const TemplatePreviewToggle = ({ mode, onChange, className = '' }) => (
    <SegmentedControl
        size="small"
        className={`model-setup-template-preview-toggle fs-unmask ${className}`.trim()}
        items={[
            { id: 'template', label: 'Template' },
            { id: 'preview', label: 'Preview' },
        ]}
        activeId={mode}
        onChange={(id) => onChange?.(id)}
    />
);

export default TemplatePreviewToggle;
